import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogOptions } from '@fleet-beat/core';

@Component({
  selector: 'fb-confirm-dialog',
  templateUrl: './confirm-dialog-container.component.html',
  styleUrls: ['./confirm-dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogContainerComponent<T> {
  options: ConfirmDialogOptions<T>;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ConfirmDialogOptions<T>,
    private dialogRef: MatDialogRef<ConfirmDialogContainerComponent<T>>,
  ) {
    this.options = data;
  }
  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(event: T | boolean): void {
    this.dialogRef.close(event);
  }
}
